"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProxyUrl = exports.createProxyUrl = void 0;
const react_1 = require("react");
const api_1 = __importDefault(require("../../lib/api"));
const createViewUrl_1 = require("./createViewUrl");
function createProxyUrl(storageKey, proxyOptions, token, proxyOnly = false, name) {
    token = token || api_1.default.getAccessToken() || '';
    // name is the file name when being accessed or saved
    const namePath = name ? `/${encodeURI(name)}` : '';
    return (0, createViewUrl_1.createViewUrl)({
        token,
        // use doc viewer if not viewing pdf file
        isDocument: !proxyOnly && !storageKey.includes('.pdf'),
        getUrl: (token) => {
            return `${proxyOptions.path}${namePath}?${proxyOptions.key}=${storageKey}&token=${token}`;
        }
    });
}
exports.createProxyUrl = createProxyUrl;
function useProxyUrl(storageKey, proxyOptions, token, proxyOnly = false, name) {
    return (0, react_1.useMemo)(() => {
        return createProxyUrl(storageKey, proxyOptions, token, proxyOnly, name);
    }, [token, storageKey, proxyOnly, name, proxyOptions]);
}
exports.useProxyUrl = useProxyUrl;
//# sourceMappingURL=useProxyUrl.js.map